export default {
  placeholder: 'Select a data source',
};
